import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useGetAffiliateByRefQuery } from "../store/apiSlice";
import { extractAffiliateCode } from "../utils/extractAffiliateCode";

export function useAffiliate() {
  const location = useLocation();
  const ref = extractAffiliateCode(location);
  const {
    data,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  } = useGetAffiliateByRefQuery(ref, {
    skip: !ref,
  });

  const affiliate = useMemo(() => {
    if (!ref || !data || !data.logo ) return null;
    
    let animalTypes = null;
    try {
      if (typeof data.shop_animal_type === "string") {
        const parsed = JSON.parse(data.shop_animal_type);
        if (Array.isArray(parsed)) {
          animalTypes = parsed.map((type) => type.toLowerCase());
        }
      }
    } catch {
      animalTypes = null;
    }

    return {
      id: data.id, // Add the ID field
      name: data.affiliate,
      logo: data.logo,
      code: data.code,
      auto_discount: data.auto_discount,
      auto_promocode: data.auto_promocode,
      about: data.company_about,
      featured_image_url: data.featured_image_url,
      label: data.default_label_image_url,
      enable_shop: data.enable_shop,
      apply_logo_on_label: data.apply_logo_on_label,
      shop_animal_type: animalTypes
    };
  }, [ref, data]);

  return { affiliate, isLoading, isFetching, isSuccess, isError };
}
